// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card[data-v-347a5f88]{position:fixed;left:calc(50% - 150px);top:36px}.copy-field[data-v-347a5f88]{max-height:150px;overflow:scroll}", ""]);
// Exports
module.exports = exports;
